import { render } from "./FragmentEditorCmp.vue?vue&type=template&id=06d3b0f3"
import script from "./FragmentEditorCmp.vue?vue&type=script&lang=js"
export * from "./FragmentEditorCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__